<script>
import { sync } from 'vuex-pathify';

export default {
  computed: {
    ...sync([
      'filter.siteId', //
      'filter.feedId',
      'keys.sites',
      'keys.feeds',
    ]),
  },

  created() {
    this.loadKeys();
  },

  methods: {
    loadKeys() {
      $.get('keys.json', (data) => {
        console.log('keys.json', data);
        this.$store.set('keys/sites', data.sites);
        this.$store.set('keys/feeds', data.feeds);
        this.$store.set('filter/siteId', this.sites[data.defaults.site]);
        this.$store.set('filter/feedId', this.feeds[data.defaults.feed]);
      });
    },
  },

  template: '<div></div>',
};
</script>
